import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { handleStartEmpireFree, CTA_PRIMARY, CTA_PRIMARY_SUB } from "@/lib/cta";

const FinalCTA = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const start = () => handleStartEmpireFree(user, navigate);

  return (
    <section className="relative py-24 lg:py-32 overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 -z-10 cf-grain" />
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400 mb-6">
          Stop ideating. Start executing.
        </p>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-black text-white tracking-tighter leading-[1.0]">
          Your empire's not going to
          <br />
          <span className="bg-gradient-to-r from-[#00F0FF] to-[#10b981] bg-clip-text text-transparent">
            automate itself.
          </span>
        </h2>
        <p className="mt-8 text-lg text-slate-300 max-w-2xl mx-auto">
          14 days. No card. 50 DMs and 2 blog posts on the house. Watch
          ClydeFlow take work off your plate before lunch.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="final-cta-trial"
            onClick={start}
            className="group px-8 py-4 bg-[#00F0FF] text-[#050B14] font-bold hover:bg-[#33F3FF] transition-all rounded-sm shadow-[0_0_40px_rgba(0,240,255,0.5)] flex flex-col items-center justify-center gap-0.5"
          >
            <span className="flex items-center gap-2 uppercase tracking-wider">
              {CTA_PRIMARY}
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </span>
            <span className="text-[10px] font-mono uppercase tracking-[0.25em] opacity-80">
              {CTA_PRIMARY_SUB}
            </span>
          </button>
          <a
            href="#pricing"
            data-testid="final-cta-mogul"
            className="px-8 py-4 bg-transparent border border-white/20 text-white font-bold hover:bg-white/5 hover:border-cyan-400/40 transition-all rounded-sm"
          >
            Get the Mogul Deal · £299
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
